import React, { Component } from 'react';
import SVGs from './SvgIcons';
import FormikForm from './FormikForm';

class FormPage extends Component {
	render() {
		const { title, onClick, answerValues, rqNumber, income } = this.props;
		return (
			<section className="form-section">
				<div className="form-section__card">
					<div className="form-section__quiz-results">
						<p className="form-section__results">Your Results:</p>
						<p className="form-section__results-title">{title}</p>
						<div className="form-section__img">{SVGs.checkmark}</div>
					</div>
					<h3 className="form-section__heading">
						Where Can We Send Your Custom Report?
					</h3>
					<p className="form-section__cta">
						By providing your information, you give consent to be contacted
						about the possible sale of an insurance or annuity product. But we
						do need a little bit more about you, so we can send your custom
						report to you!
					</p>
					<div className="form-section__form">
						<FormikForm
							income={income}
							result={rqNumber}
							answers={answerValues}
							onClick={onClick}
						/>
					</div>
				</div>
			</section>
		);
	}
}
export default FormPage;



// WEBPACK FOOTER //
// ./src/components/form/FormPage.js